import { UrlFilters } from "../../../../../../context/selectedFilters";

export const buildFilterParams = ({ featured, secondary }: UrlFilters): string[] => {
  const parsedSecondaryParams = Object.keys(secondary).map(key => `${key}-${secondary[key]}`);
  return [...featured, ...parsedSecondaryParams];
};
